import React from 'react';
import { TableRow, TableCell, Skeleton } from '@mui/material';

const TableRowSkeleton = ({ avatar = false, columns = 4 }) => {
  return (
    <TableRow>
      {avatar && (
        <TableCell>
          <Skeleton variant="circular" width={40} height={40} />
        </TableCell>
      )}
      {Array.from({ length: columns }).map((_, index) => (
        <TableCell key={index}>
          <Skeleton variant="text" />
        </TableCell>
      ))}
    </TableRow>
  );
};

export default TableRowSkeleton;